import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/cms/content')({
  staticData: { crumb: { parents: [{ label: 'CMS' }], label: 'Content' } },
})
